import { noop } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { CalculationBlock } from '../../../components/shared/calculator/CalculationBlock';
import { useAppSelector } from '../../../hooks/react-redux';
import { Calculation, CalculationCondition, CalculationType, CalculatorField, CalculatorInput, getAllPadOptions } from '../../admin/calculator/store';

interface ReadOnlyCalculatorFieldProps {
    value: CalculatorField[];
    calculation: Calculation[];
    output: CalculatorInput[];
    gracePeriod: CalculatorInput[];
    calculationCondition: CalculationCondition | null;
    calculationIndex: number;
    borderColor: string;
    boxShadow?: string;
    showOutputField: boolean;
    showGracePeriod: boolean;
}

export const ReadOnlyCalculatorField: React.FC<ReadOnlyCalculatorFieldProps> = ({
    value,
    calculation,
    output,
    gracePeriod,
    calculationCondition,
    calculationIndex,
    borderColor,
    showOutputField,
    showGracePeriod,
    boxShadow
}) => {
    const allPadOptions = useAppSelector(getAllPadOptions);
    const selectedCalculation = useMemo(() => value[0], [value]);

    const getFontSize = useCallback((optionInputType: string) => {
        const padOption = allPadOptions.find(({ inputType }) => inputType === optionInputType);
        if (padOption) {
            return padOption.config.fontSize;
        }
        return '14px';
    }, [allPadOptions]);

    return (
        <CalculationBlock
            outputValue={value}
            calculation={calculation}
            output={output}
            gracePeriod={gracePeriod}
            calculationCondition={calculationCondition}
            calculationIndex={calculationIndex}
            getFontSize={getFontSize}
            disabled={true}
            isEditing={false}
            selectedCalculation={selectedCalculation}
            selectedCalculationIndex={0}
            selectedBuilderIndex={null}
            setSelectedBuilderIndex={noop}
            setSelectedCalculationIndex={noop}
            updateSelectedCalculation={noop}
            selectedCalculationBuilder={CalculationType.OUTPUT}
            setSelectedCalculationBuilder={noop}
            key={calculationIndex}
            borderColor={borderColor}
            boxShadow={boxShadow}
            removeCalculation={noop}
            updateTextField={noop}
            showOutputField={showOutputField}
            showGracePeriod={showGracePeriod}
            canRemoveCalculationBlock={false}
        />
    );
};
